import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getTypedFormComponents } from 'Src/feature/form/getTypedFormComponents';
import { useForm } from 'Src/feature/form/useForm';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalSubTitle } from 'Src/feature/modal/ModalSubTitle';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

import styles from './CheckItemScheduleModal.module.scss';

const sectionId = 'CheckItemScheduleModal';

interface CheckItemScheduleModalProps {
  open: boolean;
  form: ReturnType<typeof useForm<{ sendAt: string, isPM: boolean }>>,
  checkItemName: string;
  onClose: () => void;
  onSave: () => void;
}

const { Form, Field } = getTypedFormComponents<{ sendAt: string, isPM: boolean }>();

const CheckItemScheduleModal: FC<CheckItemScheduleModalProps> = ({ open, form, checkItemName, onClose, onSave }) => {
  const { t } = useTranslation();

  return (
    <Modal
      data-testid={sectionId}
      open={open}
    >
      <ModalHeader>
        <ModalTitle copy={t('checkItem.labels.scheduleItem')} />
        <ModalSubTitle copy={t('checkItem.labels.scheduleInstructions', { checkItemName })} />
      </ModalHeader>
      <ModalContent flex={{ alignItems: 'center', justifyContent: 'center' }}>
        <div className={styles['wrapper']}>
          <Form usedForm={form} className={styles['form']}>
            <Field type="timeInput" name="sendAt" />
            <div className={styles['switch-wrapper']}>
              <Field type="switch" name="isPM" label={t('labels.pm')} className={styles['switch']} />
            </div>
          </Form>
        </div>
      </ModalContent>
      <ModalActions>
        <ModalAction
          label={t('labels.cancel')}
          onClick={onClose}
          color="secondary"
        />
        <ModalAction
          label={t('checkItem.labels.confirmSchedule')}
          onClick={onSave}
          color="primary"
          disabled={!form.state.isValid}
        />
      </ModalActions>
    </Modal>
  );
};

export { CheckItemScheduleModal, sectionId };
